import { fetcher, IFetcher, IFetchResponseBase } from "./api";

export async function del<T>(url: string): Promise<IFetchResponseBase> {
  return await fetcher({
    url: url,
    method: "DELETE",
  });
}
